module.exports = __webpack_public_path__ + "img/img1.37d185b9.png";